import React, { useMemo } from 'react'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'

import { TableSortingDescend, TableSortingAscend } from '../../Constants/TableConfiguration'

function CustomSort(props) {
  const downSorting = useMemo(() => {
    return props.sortInfo.columnKey === props.sortColumn && props.sortInfo.order === TableSortingDescend
  }, [props.sortColumn, props.sortInfo.order, props.sortInfo.columnKey])
  const upSorting = useMemo(() => {
    return props.sortInfo.columnKey === props.sortColumn && props.sortInfo.order === TableSortingAscend
  }, [props.sortColumn, props.sortInfo.order, props.sortInfo.columnKey])

  return (
    <span className='box-sort'>
      <span className='custom-sort-icon-container'>
        {upSorting ? (
          <CaretUpOutlined
            className='custom-sort-up active float-right'
            onClick={e => {
              props.resetSortOrder()
            }}
          />
        ) : (
          <CaretUpOutlined
            className={'custom-sort-up float-right'}
            onClick={e => {
              props.setAscendSorting(props.sortColumn)
            }}
          />
        )}
        {downSorting ? (
          <CaretDownOutlined
            className='custom-sort-down active float-right'
            onClick={e => {
              props.resetSortOrder()
            }}
          />
        ) : (
          <CaretDownOutlined
            className='custom-sort-down float-right'
            onClick={e => {
              props.setDescendSorting(props.sortColumn)
            }}
          />
        )}
      </span>
    </span>
  )
}

export default CustomSort
